import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { ViewRenderCapability } from '@aibuild/model-viewer';
import { getViewRenderOffer, renderView } from '@api/viewRender';
import useAuth from '@contexts/useAuth';

const OFFER_KEY = ['viewRenderOffer'] as const;
const OFFER_STALE_MS = 5 * 60_000;

/** AI renders for a signed-in user, charged to their organisation; none without a user. */
export function useViewRenderCapability(): ViewRenderCapability | undefined {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const signedIn = Boolean(user);
  return useMemo(() => {
    if (!signedIn) return undefined;
    return {
      loadOffer: () =>
        queryClient.fetchQuery({ queryKey: OFFER_KEY, queryFn: getViewRenderOffer, staleTime: OFFER_STALE_MS }),
      render: async (request, signal) => {
        const result = await renderView(request, signal);
        void queryClient.invalidateQueries({ queryKey: ['billingOverview'] });
        return result;
      },
    };
  }, [signedIn, queryClient]);
}
